import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '使用教程', path: '/category/tutorial' },
      { label: '常见问题', path: '/category/faq' },
      { label: '安全指南', path: '/category/security' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '最新动态', path: '/category/news' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '热门文章',
    links: [
      { label: '最新入口地址', path: '/article/91n-com-zuixin-rukou-dizhi' },
      { label: '新手使用教程', path: '/article/91n-com-xinshou-jiaocheng' },
      { label: '常见问题解答', path: '/article/91n-com-changjian-wenti-jieda' },
      { label: '安全访问指南', path: '/article/91n-com-anquan-fangwen-zhinan' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-global-line text-lg"></i>
              </div>
              <span className="font-semibold text-foreground-950">91n com 官方入口</span>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">
              提供 91n com 最新访问地址、使用教程、安全指南和常见问题解答，帮助用户安全便捷地使用平台服务。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-semibold text-foreground-950 mb-3 text-sm">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-foreground-600 hover:text-primary-600 text-sm transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 91n com 官方入口指南 - 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors" rel="nofollow">免责声明</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}